module.exports = __webpack_public_path__ + "static/media/arrow_xl_l.26ec3326.svg";